export const portalIsProduction = () =>
  window.location.href.includes("app.gymflow.io");
export const portalIsLocalhost = () =>
  window.location.href.includes("localhost") ||
  window.location.href.includes("192.168.1");
